import React from 'react';
import LoginForm from './LoginForm';
// image from https://unsplash.com/@linkedinsalesnavigator
import AuthPageSkeleton from '../components/AuthPageSkeleton';
import { goToHomePage, hasToken } from '../../../services/auth';

/**
 * @component for login page
 */
const Login: React.FC = () => {
  const isAuthenticated = hasToken();

  if (isAuthenticated) {
    goToHomePage();
    return <></>;
  }

  return (
    <AuthPageSkeleton>
      <LoginForm />
    </AuthPageSkeleton>
  );
};

export default Login;
